module.exports = __webpack_public_path__ + "static/img/si.1edcc53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/si.jpg
// module id = mQF+
// module chunks = 1